import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paypal-component',
  templateUrl: './paypal-component.component.html',
  styleUrls: ['./paypal-component.component.css']
})
export class PaypalComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/paypal-component/paypal-component.component.ts